import { ExchangeTokenWithCacheFactory, SilentAuthWithCacheFactory } from '@notes/webintegrations-common'
import { exchangeTokenCache, implicitAuthCache } from '../caches'
import { IGetToken } from './IGetToken'
import { MsaGetToken } from './MsaGetToken'
import { O365GetToken } from './O365GetToken'

export class GetTokenFactory {
  static createMsa(forceRefresh: boolean): IGetToken {
    return new MsaGetToken(SilentAuthWithCacheFactory.create(implicitAuthCache, forceRefresh))
  }

  static createO365(accessToken: string, tenantId: string, forceRefresh: boolean): IGetToken {
    return new O365GetToken(ExchangeTokenWithCacheFactory.create(exchangeTokenCache, forceRefresh), accessToken, tenantId)
  }
}
